// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===================================
   ZIFRAMED DESIGN SYSTEM
   Sistema de diseño basado en mockups
   =================================== */

:root {
  --bg-app: #f3f2f8;
  --bg-surface: #fcfbff;
  --bg-card: #f9f8fd;
  --border-soft: #e7e0f2;
  --border-mid: #ddd4ee;
  --text-main: #2c2150;
  --text-soft: #84799f;
  --primary: #7d23ff;
  --primary-2: #346dff;
  --sidebar-bg-top: #14003a;
  --sidebar-bg-bottom: #0f022d;
  --white: #ffffff;
}

/* ===================================
   LAYOUT
   =================================== */

.zf-app-shell {
  display: flex;
  min-height: 100vh;
  height: 100vh;
  width: 100%;
  overflow: hidden;
}

.zf-main {
  flex: 1 1;
  min-width: 0;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px;
}

/* ===================================
   SIDEBAR
   =================================== */

.zf-sidebar {
  width: 280px;
  min-width: 280px;
  height: 100vh;
  background: linear-gradient(180deg, #14003a 0%, #0f022d 100%);
  background: linear-gradient(180deg, var(--sidebar-bg-top) 0%, var(--sidebar-bg-bottom) 100%);
  color: #ffffff;
  color: var(--white);
  padding: 18px 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-right: 1px solid rgba(255, 255, 255, 0.08);
  overflow-y: auto;
}

.zf-sidebar__mobile-close {
  display: none;
}

/* ===================================
   MOBILE TOPBAR + DRAWER
   (la barra lateral en si se activa via
   .zf-sidebar--mobile-open, definido en el
   media query de abajo)
   =================================== */

.zf-mobile-topbar {
  display: none;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  background: linear-gradient(180deg, #14003a 0%, #0f022d 100%);
  background: linear-gradient(180deg, var(--sidebar-bg-top) 0%, var(--sidebar-bg-bottom) 100%);
  color: #ffffff;
  color: var(--white);
  position: sticky;
  top: 0;
  z-index: 20;
}

.zf-mobile-topbar__burger {
  width: 38px;
  height: 38px;
  border: none;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
  color: var(--white);
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.zf-mobile-topbar__title {
  font-size: 15px;
  font-weight: 600;
}

.zf-mobile-topbar__avatar {
  width: 32px;
  height: 32px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 12px;
}

.zf-sidebar-overlay {
  display: none;
}

.zf-sidebar__profile {
  display: grid;
  grid-template-columns: 44px 1fr 40px;
  grid-gap: 14px;
  gap: 14px;
  align-items: start;
  padding: 2px 0 18px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.zf-sidebar__avatar {
  width: 44px;
  height: 44px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
}

.zf-sidebar__profile-info h2 {
  margin: 0;
  font-size: 16px;
  line-height: 1.35;
}

.zf-sidebar__profile-info p {
  margin: 4px 0 6px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.82);
}

.zf-sidebar__profile-info span {
  display: block;
  font-size: 11px;
  letter-spacing: 0.12em;
  color: rgba(255, 255, 255, 0.56);
}

.zf-pendientes-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 14px;
  padding: 9px 14px;
  border-radius: 999px;
  background: rgba(255, 184, 76, 0.14);
  color: #ffcf87;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease;
}

.zf-pendientes-badge:hover {
  background: rgba(255, 184, 76, 0.22);
}

.zf-pendientes-badge__icon {
  font-size: 14px;
}

.zf-sidebar__nav {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 14px;
}

.zf-nav-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 11px 14px;
  border-radius: 14px;
  color: rgba(255, 255, 255, 0.86);
  font-weight: 500;
  transition: 0.2s ease;
  cursor: pointer;
  text-decoration: none;
}

.zf-nav-item:hover {
  background: rgba(255, 255, 255, 0.08);
}

.zf-nav-item.active {
  background: linear-gradient(90deg, #8d1dff 0%, #326cff 100%);
  color: #ffffff;
  font-weight: 600;
  box-shadow: 0 10px 30px rgba(94, 65, 255, 0.35);
}

.zf-nav-item__icon {
  width: 22px;
  text-align: center;
  font-size: 16px;
}

/* Submenu Styles */
.zf-submenu {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 6px;
  margin-left: 36px;
  padding-left: 16px;
  border-left: 2px solid rgba(255, 255, 255, 0.15);
}

.zf-submenu-item {
  display: block;
  padding: 10px 14px;
  border-radius: 12px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  transition: 0.2s ease;
  cursor: pointer;
}

.zf-submenu-item:hover {
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.95);
}

.zf-submenu-item.active {
  background: rgba(141, 29, 255, 0.3);
  color: #ffffff;
  font-weight: 600;
}

.zf-sidebar__footer-card {
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.06);
  border-radius: 18px;
  padding: 14px;
}

.zf-sidebar__footer-label {
  display: block;
  font-size: 11px;
  letter-spacing: 0.18em;
  color: rgba(255, 255, 255, 0.56);
  margin-bottom: 8px;
}

.zf-sidebar__footer-card strong {
  display: block;
  font-size: 18px;
  margin-bottom: 6px;
}

.zf-sidebar__footer-card p {
  margin: 0;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.72);
}

/* ===================================
   CARDS
   =================================== */

.zf-card {
  background: #fcfbff;
  background: var(--bg-surface);
  border: 1px solid #e7e0f2;
  border: 1px solid var(--border-soft);
  border-radius: 28px;
  overflow: hidden;
  box-shadow: 0 12px 40px rgba(45, 28, 90, 0.06);
}

.zf-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 26px 26px 22px;
  border-bottom: 1px solid #ebe5f4;
}

.zf-card__header h1,
.zf-card__header h2 {
  margin: 0 0 6px;
  font-size: 22px;
  color: #2c2150;
  color: var(--text-main);
}

.zf-card__header p {
  margin: 0;
  color: #84799f;
  color: var(--text-soft);
}

.zf-card__body {
  padding: 22px;
}

/* ===================================
   BUTTONS
   =================================== */

.zf-btn {
  height: 44px;
  padding: 0 20px;
  border-radius: 16px;
  border: 1px solid #ddd4ee;
  border: 1px solid var(--border-mid);
  background: #ffffff;
  color: #4a3c78;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s ease;
  white-space: nowrap;
  font-family: inherit;
  font-size: 14px;
}

.zf-btn:hover {
  transform: translateY(-1px);
}

.zf-btn--gradient {
  border: none;
  color: #ffffff;
  background: linear-gradient(90deg, #8b1eff 0%, #3c68ff 100%);
  box-shadow: 0 10px 24px rgba(88, 62, 255, 0.28);
}

.zf-btn--ghost {
  background: #ffffff;
  color: #4f4672;
}

.zf-btn--outline {
  background: #ffffff;
  color: #6b57a8;
  border: 1px solid #ddd1fa;
}

/* ===================================
   BADGES
   =================================== */

.zf-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 28px;
  padding: 0 14px;
  border-radius: 999px;
  background: #efe9ff;
  color: #6c3bff;
  font-size: 13px;
  font-weight: 600;
}

.zf-badge--soft {
  background: #f3efff;
  color: #7a58e6;
}

.zf-chip {
  display: inline-flex;
  align-items: center;
  min-height: 30px;
  padding: 0 12px;
  border-radius: 999px;
  background: #f1ecff;
  color: #7d23ff;
  font-size: 13px;
  font-weight: 600;
}

/* ===================================
   INFO TILE GRID
   (ficha de datos personales - "Ver Paciente",
   mismo lenguaje visual que el panel de
   paciente de la barra lateral)
   =================================== */

.zf-info-tile-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 10px;
  gap: 10px;
  margin-bottom: 16px;
}

@media (min-width: 700px) {
  .zf-info-tile-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

.zf-info-tile {
  border: 1px solid #e7e0f2;
  border: 1px solid var(--border-soft);
  border-radius: 12px;
  padding: 10px 12px;
  background: #f9f8fd;
  background: var(--bg-card);
}

.zf-info-tile__label {
  font-size: 11px;
  color: #84799f;
  color: var(--text-soft);
  margin-bottom: 3px;
}

.zf-info-tile__value {
  font-size: 13px;
  color: #2c2150;
  color: var(--text-main);
  font-weight: 500;
  word-break: break-word;
}

.zf-info-tile.empty .zf-info-tile__value {
  color: #84799f;
  color: var(--text-soft);
  font-weight: 400;
}

/* ===================================
   DOCUMENT BROWSER (Documentos clinicos)
   =================================== */

.zf-dropzone {
  border: 2px dashed #ddd4ee;
  border: 2px dashed var(--border-mid);
  border-radius: 16px;
  padding: 24px 20px;
  text-align: center;
  background: #f9f8fd;
  background: var(--bg-card);
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
}

.zf-dropzone.dragover {
  border-color: #7d23ff;
  border-color: var(--primary);
  background: #f1ecff;
}

.zf-dropzone__icon {
  font-size: 24px;
  color: #84799f;
  color: var(--text-soft);
  margin-bottom: 6px;
}

.zf-dropzone__main {
  font-size: 14px;
  font-weight: 600;
  color: #2c2150;
  color: var(--text-main);
  margin-bottom: 4px;
}

.zf-dropzone__sub {
  font-size: 12px;
  color: #84799f;
  color: var(--text-soft);
}

.zf-selected-file {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 12px;
  padding: 9px 12px;
  border: 1px solid #e7e0f2;
  border: 1px solid var(--border-soft);
  border-radius: 12px;
  background: #f9f8fd;
  background: var(--bg-card);
  font-size: 13px;
}

.zf-selected-file__name {
  font-weight: 600;
  flex: 1 1;
}

.zf-selected-file__remove {
  cursor: pointer;
  color: #84799f;
  color: var(--text-soft);
  font-size: 15px;
}

.zf-field-row {
  margin-top: 12px;
}

.zf-field-row label {
  display: block;
  font-size: 12px;
  color: #84799f;
  color: var(--text-soft);
  margin-bottom: 6px;
}

.zf-field-row input[type="text"] {
  width: 100%;
  padding: 9px 12px;
  border: 1px solid #ddd4ee;
  border: 1px solid var(--border-mid);
  border-radius: 10px;
  font-size: 14px;
  font-family: inherit;
}

.zf-btn-gradient {
  padding: 9px 18px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  color: #fff;
  background: linear-gradient(90deg, #8b1eff 0%, #3c68ff 100%);
  font-family: inherit;
}

.zf-btn-gradient:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.zf-search-box {
  flex: 1 1;
  min-width: 180px;
  max-width: 260px;
  padding: 7px 12px;
  border: 1px solid #ddd4ee;
  border: 1px solid var(--border-mid);
  border-radius: 10px;
  font-size: 13px;
  font-family: inherit;
}

.zf-doc-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 320px;
  overflow-y: auto;
}

.zf-doc-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 9px 12px;
  border: 1px solid #e7e0f2;
  border: 1px solid var(--border-soft);
  border-radius: 12px;
  background: #fcfbff;
  background: var(--bg-surface);
}

.zf-doc-row__icon {
  font-size: 18px;
  color: #84799f;
  color: var(--text-soft);
  flex-shrink: 0;
  display: flex;
}

.zf-doc-row__icon .material-icons {
  font-size: 20px;
}

.zf-doc-row__info {
  flex: 1 1;
  min-width: 0;
}

.zf-doc-row__name {
  font-size: 13px;
  font-weight: 600;
  color: #2c2150;
  color: var(--text-main);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.zf-doc-row__meta {
  font-size: 11px;
  color: #84799f;
  color: var(--text-soft);
  margin-top: 2px;
}

.zf-doc-row__tag {
  font-size: 10px;
  padding: 2px 8px;
  border-radius: 999px;
  background: #f1ecff;
  color: #7d23ff;
  color: var(--primary);
  font-weight: 600;
  white-space: nowrap;
}

.zf-doc-row__tag--empty {
  opacity: 0.5;
}

.zf-doc-row__actions {
  display: flex;
  gap: 6px;
}

.zf-doc-row__actions button {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  border: 1px solid #ddd4ee;
  border: 1px solid var(--border-mid);
  background: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #84799f;
  color: var(--text-soft);
}

.zf-doc-row__actions .material-icons {
  font-size: 16px;
}

.zf-doc-row--eliminado {
  background: #f7f5fc;
  opacity: 0.85;
}

.zf-doc-row--eliminado .zf-doc-row__name {
  text-decoration: line-through;
  color: #84799f;
  color: var(--text-soft);
  font-weight: 500;
}

.zf-doc-row__motivo {
  font-size: 11px;
  color: #84799f;
  color: var(--text-soft);
  font-style: italic;
  margin-top: 2px;
  white-space: normal;
}

/* ===================================
   INPUTS
   =================================== */

.zf-input,
.zf-select,
.zf-textarea {
  width: 100%;
  min-height: 44px;
  border-radius: 14px;
  border: 1px solid #dcd6e8;
  background: #ffffff;
  padding: 12px 14px;
  outline: none;
  font-size: 14px;
  color: #2c2150;
  color: var(--text-main);
  font-family: inherit;
}

.zf-textarea {
  min-height: 110px;
  resize: vertical;
}

.zf-input:focus,
.zf-select:focus,
.zf-textarea:focus {
  border-color: #bbaaf6;
  box-shadow: 0 0 0 4px rgba(130, 90, 255, 0.08);
}

/* ===================================
   SEARCH
   =================================== */

.zf-search {
  flex: 1 1;
  max-width: 460px;
  position: relative;
}

.zf-search__icon {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 14px;
  opacity: 0.75;
}

.zf-search input {
  width: 100%;
  height: 46px;
  border-radius: 16px;
  border: 1px solid #ddd4ee;
  border: 1px solid var(--border-mid);
  background: #ffffff;
  padding: 0 16px 0 44px;
  outline: none;
  font-size: 14px;
  color: #2c2150;
  color: var(--text-main);
  box-shadow: 0 2px 8px rgba(34, 24, 68, 0.04);
}

.zf-search input:focus {
  border-color: #bbaaf6;
  box-shadow: 0 0 0 4px rgba(130, 90, 255, 0.08);
}

/* ===================================
   TOPBAR
   =================================== */

.zf-topbar {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 22px 28px 18px;
}

.zf-topbar__actions {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
}

/* ===================================
   PATIENT PANEL (SIDEBAR)
   =================================== */

.zf-patient-panel {
  margin-top: 18px;
  padding: 16px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 18px;
}

.zf-patient-panel__label {
  display: block;
  font-size: 11px;
  letter-spacing: 0.18em;
  color: rgba(255, 255, 255, 0.56);
  margin-bottom: 10px;
}

.zf-patient-panel h3 {
  margin: 0 0 8px;
  font-size: 16px;
  line-height: 1.35;
  color: #ffffff;
}

.zf-patient-panel__sub {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.82);
  margin-bottom: 14px;
}

.zf-patient-panel__data {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding-top: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.zf-patient-panel__data p {
  margin: 0;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.72);
}

.zf-patient-panel__data strong {
  color: rgba(255, 255, 255, 0.92);
  font-weight: 600;
}

.zf-patient-panel__chip-row {
  display: flex;
  gap: 6px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.zf-patient-panel__chip {
  font-size: 11px;
  padding: 3px 9px;
  border-radius: 999px;
  background: rgba(141, 29, 255, 0.35);
  color: #e6d6ff;
  font-weight: 600;
}

.zf-patient-panel__vermas {
  margin-top: 10px;
  background: none;
  border: none;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.6);
  font-size: 11px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0;
  font-family: inherit;
}

.zf-patient-panel__vermas-arrow {
  transition: transform 0.15s ease;
  display: inline-block;
}

.zf-patient-panel__vermas.open .zf-patient-panel__vermas-arrow {
  transform: rotate(180deg);
}

.zf-patient-panel__extra {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.zf-patient-panel__extra p {
  margin: 0;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.72);
}

.zf-patient-panel__extra strong {
  color: rgba(255, 255, 255, 0.92);
  font-weight: 600;
}

/* ===================================
   COLLAPSIBLE SECTIONS
   =================================== */

.zf-section-box {
  background: #fcfbff;
  background: var(--bg-surface);
  border: 1px solid #e7e0f2;
  border: 1px solid var(--border-soft);
  border-radius: 18px;
  margin-bottom: 16px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.zf-section-box__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 22px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.zf-section-box__title-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.zf-section-box__header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #2c2150;
  color: var(--text-main);
}

.zf-section-box__toggle {
  width: 32px;
  height: 32px;
  border-radius: 10px;
  border: 1px solid #ddd4ee;
  border: 1px solid var(--border-mid);
  background: white;
  color: #7d23ff;
  color: var(--primary);
  font-size: 20px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.zf-section-box__toggle:hover {
  background: #f9f8fd;
  background: var(--bg-card);
  border-color: #7d23ff;
  border-color: var(--primary);
}

.zf-section-box__body {
  padding: 0 22px 22px;
  display: none;
}

.zf-section-box.is-open .zf-section-box__body {
  display: block;
}

.zf-section-box.is-collapsed .zf-section-box__body {
  display: none;
}

/* ===================================
   MINI BADGE (OBLIGATORIO)
   =================================== */

.zf-mini-badge {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 12px;
  border-radius: 999px;
  background: #fff3e6;
  color: #e67700;
  font-family: 'Rubik', sans-serif;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.zf-mini-badge--required {
  background: #ffe6e6;
  color: #cc0000;
}

.zf-mini-badge--info {
  background: #e6f3ff;
  color: #0066cc;
}

.zf-mini-badge--brand {
  background: #f1ecff;
  color: #7d23ff;
}

.zf-mini-badge--action {
  border: none;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  margin: 1px 0 0;
  vertical-align: top;
  cursor: pointer;
  transition: filter 0.15s ease;
}

.zf-mini-badge--action:hover {
  filter: brightness(0.95);
}

.zf-mini-badge--action:disabled {
  cursor: default;
  opacity: 0.5;
}

/* ===================================
   CONSULT LAYOUT
   =================================== */

.zf-consult-wrapper {
  flex: 1 1;
  overflow-y: auto;
  padding: 24px 28px;
}

.zf-consult-card {
  background: #fcfbff;
  background: var(--bg-surface);
  border: 1px solid #e7e0f2;
  border: 1px solid var(--border-soft);
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(44, 33, 80, 0.06);
}

.zf-consult-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 24px;
  padding: 24px 28px;
  border-bottom: 1px solid #e7e0f2;
  border-bottom: 1px solid var(--border-soft);
}

/* Los distintivos no se encogen (flex-shrink: 0 mas abajo), asi que todo el
   apretujon caia sobre el nombre del paciente: con edad, tipo de cita y
   modalidad en la misma fila, quedaba en "Ju...". Ahora la fila envuelve y el
   nombre tiene un piso: si falta espacio bajan los distintivos, no el nombre. */
.zf-consult-card__title-row {
  display: flex;
  align-items: center;
  gap: 12px;
  row-gap: 8px;
  flex-wrap: wrap;
  flex: 1 1 260px;
  min-width: 0;
}

.zf-consult-card__title-row h2 {
  margin: 0;
  font-size: 22px;
  color: #2c2150;
  color: var(--text-main);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  /* Piso legible: sigue recortando con puntos suspensivos si el nombre es muy
     largo, pero nunca se reduce a dos letras. */
  min-width: 180px;
}

.zf-consult-card__title-row .zf-chip {
  flex-shrink: 0;
}

.zf-consult-card__header-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  flex-shrink: 0;
}

.zf-consult-layout {
  display: grid;
  grid-template-columns: 1fr 320px;
  grid-gap: 24px;
  gap: 24px;
  padding: 24px 28px;
}

.zf-consult-maincol {
  min-width: 0;
}

.zf-consult-sidebar {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* ===================================
   CONSULT TOPBAR
   =================================== */

.zf-consult-topbar {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 22px 28px 18px;
  border-bottom: 1px solid #e7e0f2;
  border-bottom: 1px solid var(--border-soft);
}

.zf-consult-topbar__eyebrow {
  display: block;
  font-size: 11px;
  letter-spacing: 0.14em;
  color: #84799f;
  color: var(--text-soft);
  margin-bottom: 6px;
  text-transform: uppercase;
}

.zf-consult-topbar__title {
  margin: 0;
  font-size: 26px;
  color: #2c2150;
  color: var(--text-main);
}

/* ===================================
   RESPONSIVE
   =================================== */

@media (max-width: 1180px) {
  .zf-topbar {
    flex-direction: column;
    align-items: stretch;
  }

  .zf-search {
    max-width: none;
  }

  .zf-consult-layout {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 980px) {
  .zf-sidebar {
    display: none;
  }

  .zf-sidebar.zf-sidebar--mobile-open {
    display: flex;
    position: fixed;
    inset: 0 auto 0 0;
    width: 84%;
    max-width: 300px;
    min-width: 0;
    z-index: 31;
    box-shadow: 0 0 40px rgba(0, 0, 0, 0.35);
  }

  .zf-sidebar__mobile-close {
    display: flex;
    align-self: flex-end;
    width: 32px;
    height: 32px;
    border: none;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.1);
    color: #ffffff;
    color: var(--white);
    font-size: 16px;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-bottom: 8px;
  }

  .zf-mobile-topbar {
    display: flex;
  }

  .zf-sidebar-overlay {
    display: block;
    position: fixed;
    inset: 0;
    background: rgba(10, 5, 30, 0.5);
    z-index: 30;
  }

  .zf-app-shell {
    flex-direction: column;
    height: auto;
    min-height: 100vh;
    overflow: visible;
  }

  .zf-main {
    height: auto;
    overflow: visible;
  }

  .zf-topbar {
    padding: 16px;
  }

  .zf-consult-wrapper {
    padding: 16px;
  }

  .zf-consult-card__header {
    flex-direction: column;
    align-items: stretch;
  }
}

/* Reduccion de padding especifica para telefonos - el breakpoint de arriba
   (980px) sigue cubriendo tablets, que tienen espacio de sobra y no lo
   necesitan; este es mas angosto a proposito. */
@media (max-width: 600px) {
  .zf-main {
    padding: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/ziframed-design-system.css"],"names":[],"mappings":"AAAA;;;wCAGwC;;AAExC;EACE,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,yBAAyB;EACzB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;;wCAEwC;;AAExC;EACE,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;;wCAEwC;;AAExC;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,6DAA4F;EAA5F,4FAA4F;EAC5F,cAAmB;EAAnB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;wCAKwC;;AAExC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,6DAA4F;EAA5F,4FAA4F;EAC5F,cAAmB;EAAnB,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,cAAmB;EAAnB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,cAAS;EAAT,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,4DAA4D;EAC5D,cAAc;EACd,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gCAAgC;AAClC;;AAEA;;wCAEwC;;AAExC;EACE,mBAA6B;EAA7B,6BAA6B;EAC7B,yBAAoC;EAApC,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;;EAEE,eAAe;EACf,eAAe;EACf,cAAuB;EAAvB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,cAAuB;EAAvB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;;wCAEwC;;AAExC;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yBAAmC;EAAnC,mCAAmC;EACnC,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,4DAA4D;EAC5D,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;wCAEwC;;AAExC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;;wCAKwC;;AAExC;EACE,aAAa;EACb,qCAAqC;EACrC,cAAS;EAAT,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,yBAAoC;EAApC,oCAAoC;EACpC,mBAAmB;EACnB,kBAAkB;EAClB,mBAA0B;EAA1B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,cAAuB;EAAvB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAuB;EAAvB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAuB;EAAvB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;wCAEwC;;AAExC;EACE,0BAAoC;EAApC,oCAAoC;EACpC,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAA0B;EAA1B,0BAA0B;EAC1B,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,qBAA4B;EAA5B,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAuB;EAAvB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAuB;EAAvB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAuB;EAAvB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,yBAAoC;EAApC,oCAAoC;EACpC,mBAAmB;EACnB,mBAA0B;EAA1B,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,eAAe;EACf,cAAuB;EAAvB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAuB;EAAvB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAmC;EAAnC,mCAAmC;EACnC,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,4DAA4D;EAC5D,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAmC;EAAnC,mCAAmC;EACnC,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,yBAAoC;EAApC,oCAAoC;EACpC,mBAAmB;EACnB,mBAA6B;EAA7B,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAuB;EAAvB,uBAAuB;EACvB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAuB;EAAvB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAuB;EAAvB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAqB;EAArB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAmC;EAAnC,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAuB;EAAvB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,cAAuB;EAAvB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAuB;EAAvB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;;wCAEwC;;AAExC;;;EAGE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,cAAuB;EAAvB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;EAGE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;;wCAEwC;;AAExC;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAmC;EAAnC,mCAAmC;EACnC,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,cAAuB;EAAvB,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;;wCAEwC;;AAExC;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;;wCAEwC;;AAExC;EACE,gBAAgB;EAChB,aAAa;EACb,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,oCAAoC;EACpC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;;wCAEwC;;AAExC;EACE,mBAA6B;EAA7B,6BAA6B;EAC7B,yBAAoC;EAApC,oCAAoC;EACpC,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAuB;EAAvB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAmC;EAAnC,mCAAmC;EACnC,iBAAiB;EACjB,cAAqB;EAArB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mBAA0B;EAA1B,0BAA0B;EAC1B,qBAA4B;EAA5B,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;;wCAEwC;;AAExC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;;wCAEwC;;AAExC;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAA6B;EAA7B,6BAA6B;EAC7B,yBAAoC;EAApC,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,gCAA2C;EAA3C,2CAA2C;AAC7C;;AAEA;;;gFAGgF;AAChF;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAuB;EAAvB,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB;gDAC8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,cAAS;EAAT,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;wCAEwC;;AAExC;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,gCAA2C;EAA3C,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,cAAuB;EAAvB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAuB;EAAvB,uBAAuB;AACzB;;AAEA;;wCAEwC;;AAExC;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,wCAAwC;EAC1C;;EAEA;IACE,aAAa;IACb,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,oCAAoC;IACpC,cAAmB;IAAnB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,eAAe;IACf,QAAQ;IACR,gCAAgC;IAChC,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;AACF;;AAEA;;gDAEgD;AAChD;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["/* ===================================\r\n   ZIFRAMED DESIGN SYSTEM\r\n   Sistema de diseño basado en mockups\r\n   =================================== */\r\n\r\n:root {\r\n  --bg-app: #f3f2f8;\r\n  --bg-surface: #fcfbff;\r\n  --bg-card: #f9f8fd;\r\n  --border-soft: #e7e0f2;\r\n  --border-mid: #ddd4ee;\r\n  --text-main: #2c2150;\r\n  --text-soft: #84799f;\r\n  --primary: #7d23ff;\r\n  --primary-2: #346dff;\r\n  --sidebar-bg-top: #14003a;\r\n  --sidebar-bg-bottom: #0f022d;\r\n  --white: #ffffff;\r\n}\r\n\r\n/* ===================================\r\n   LAYOUT\r\n   =================================== */\r\n\r\n.zf-app-shell {\r\n  display: flex;\r\n  min-height: 100vh;\r\n  height: 100vh;\r\n  width: 100%;\r\n  overflow: hidden;\r\n}\r\n\r\n.zf-main {\r\n  flex: 1;\r\n  min-width: 0;\r\n  height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  padding: 20px;\r\n}\r\n\r\n/* ===================================\r\n   SIDEBAR\r\n   =================================== */\r\n\r\n.zf-sidebar {\r\n  width: 280px;\r\n  min-width: 280px;\r\n  height: 100vh;\r\n  background: linear-gradient(180deg, var(--sidebar-bg-top) 0%, var(--sidebar-bg-bottom) 100%);\r\n  color: var(--white);\r\n  padding: 18px 16px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  border-right: 1px solid rgba(255, 255, 255, 0.08);\r\n  overflow-y: auto;\r\n}\r\n\r\n.zf-sidebar__mobile-close {\r\n  display: none;\r\n}\r\n\r\n/* ===================================\r\n   MOBILE TOPBAR + DRAWER\r\n   (la barra lateral en si se activa via\r\n   .zf-sidebar--mobile-open, definido en el\r\n   media query de abajo)\r\n   =================================== */\r\n\r\n.zf-mobile-topbar {\r\n  display: none;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  padding: 12px 16px;\r\n  background: linear-gradient(180deg, var(--sidebar-bg-top) 0%, var(--sidebar-bg-bottom) 100%);\r\n  color: var(--white);\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 20;\r\n}\r\n\r\n.zf-mobile-topbar__burger {\r\n  width: 38px;\r\n  height: 38px;\r\n  border: none;\r\n  border-radius: 10px;\r\n  background: rgba(255, 255, 255, 0.1);\r\n  color: var(--white);\r\n  font-size: 18px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n}\r\n\r\n.zf-mobile-topbar__title {\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n}\r\n\r\n.zf-mobile-topbar__avatar {\r\n  width: 32px;\r\n  height: 32px;\r\n  border-radius: 10px;\r\n  background: rgba(255, 255, 255, 0.12);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-weight: 700;\r\n  font-size: 12px;\r\n}\r\n\r\n.zf-sidebar-overlay {\r\n  display: none;\r\n}\r\n\r\n.zf-sidebar__profile {\r\n  display: grid;\r\n  grid-template-columns: 44px 1fr 40px;\r\n  gap: 14px;\r\n  align-items: start;\r\n  padding: 2px 0 18px;\r\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\r\n}\r\n\r\n.zf-sidebar__avatar {\r\n  width: 44px;\r\n  height: 44px;\r\n  border-radius: 14px;\r\n  background: rgba(255, 255, 255, 0.12);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-weight: 700;\r\n}\r\n\r\n.zf-sidebar__profile-info h2 {\r\n  margin: 0;\r\n  font-size: 16px;\r\n  line-height: 1.35;\r\n}\r\n\r\n.zf-sidebar__profile-info p {\r\n  margin: 4px 0 6px;\r\n  font-size: 13px;\r\n  color: rgba(255, 255, 255, 0.82);\r\n}\r\n\r\n.zf-sidebar__profile-info span {\r\n  display: block;\r\n  font-size: 11px;\r\n  letter-spacing: 0.12em;\r\n  color: rgba(255, 255, 255, 0.56);\r\n}\r\n\r\n.zf-pendientes-badge {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin-top: 14px;\r\n  padding: 9px 14px;\r\n  border-radius: 999px;\r\n  background: rgba(255, 184, 76, 0.14);\r\n  color: #ffcf87;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background 0.15s ease;\r\n}\r\n\r\n.zf-pendientes-badge:hover {\r\n  background: rgba(255, 184, 76, 0.22);\r\n}\r\n\r\n.zf-pendientes-badge__icon {\r\n  font-size: 14px;\r\n}\r\n\r\n.zf-sidebar__nav {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n  margin-top: 14px;\r\n}\r\n\r\n.zf-nav-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 11px 14px;\r\n  border-radius: 14px;\r\n  color: rgba(255, 255, 255, 0.86);\r\n  font-weight: 500;\r\n  transition: 0.2s ease;\r\n  cursor: pointer;\r\n  text-decoration: none;\r\n}\r\n\r\n.zf-nav-item:hover {\r\n  background: rgba(255, 255, 255, 0.08);\r\n}\r\n\r\n.zf-nav-item.active {\r\n  background: linear-gradient(90deg, #8d1dff 0%, #326cff 100%);\r\n  color: #ffffff;\r\n  font-weight: 600;\r\n  box-shadow: 0 10px 30px rgba(94, 65, 255, 0.35);\r\n}\r\n\r\n.zf-nav-item__icon {\r\n  width: 22px;\r\n  text-align: center;\r\n  font-size: 16px;\r\n}\r\n\r\n/* Submenu Styles */\r\n.zf-submenu {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n  margin-top: 6px;\r\n  margin-left: 36px;\r\n  padding-left: 16px;\r\n  border-left: 2px solid rgba(255, 255, 255, 0.15);\r\n}\r\n\r\n.zf-submenu-item {\r\n  display: block;\r\n  padding: 10px 14px;\r\n  border-radius: 12px;\r\n  color: rgba(255, 255, 255, 0.7);\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  text-decoration: none;\r\n  transition: 0.2s ease;\r\n  cursor: pointer;\r\n}\r\n\r\n.zf-submenu-item:hover {\r\n  background: rgba(255, 255, 255, 0.08);\r\n  color: rgba(255, 255, 255, 0.95);\r\n}\r\n\r\n.zf-submenu-item.active {\r\n  background: rgba(141, 29, 255, 0.3);\r\n  color: #ffffff;\r\n  font-weight: 600;\r\n}\r\n\r\n.zf-sidebar__footer-card {\r\n  border: 1px solid rgba(255, 255, 255, 0.1);\r\n  background: rgba(255, 255, 255, 0.06);\r\n  border-radius: 18px;\r\n  padding: 14px;\r\n}\r\n\r\n.zf-sidebar__footer-label {\r\n  display: block;\r\n  font-size: 11px;\r\n  letter-spacing: 0.18em;\r\n  color: rgba(255, 255, 255, 0.56);\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.zf-sidebar__footer-card strong {\r\n  display: block;\r\n  font-size: 18px;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.zf-sidebar__footer-card p {\r\n  margin: 0;\r\n  font-size: 13px;\r\n  color: rgba(255, 255, 255, 0.72);\r\n}\r\n\r\n/* ===================================\r\n   CARDS\r\n   =================================== */\r\n\r\n.zf-card {\r\n  background: var(--bg-surface);\r\n  border: 1px solid var(--border-soft);\r\n  border-radius: 28px;\r\n  overflow: hidden;\r\n  box-shadow: 0 12px 40px rgba(45, 28, 90, 0.06);\r\n}\r\n\r\n.zf-card__header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 18px;\r\n  padding: 26px 26px 22px;\r\n  border-bottom: 1px solid #ebe5f4;\r\n}\r\n\r\n.zf-card__header h1,\r\n.zf-card__header h2 {\r\n  margin: 0 0 6px;\r\n  font-size: 22px;\r\n  color: var(--text-main);\r\n}\r\n\r\n.zf-card__header p {\r\n  margin: 0;\r\n  color: var(--text-soft);\r\n}\r\n\r\n.zf-card__body {\r\n  padding: 22px;\r\n}\r\n\r\n/* ===================================\r\n   BUTTONS\r\n   =================================== */\r\n\r\n.zf-btn {\r\n  height: 44px;\r\n  padding: 0 20px;\r\n  border-radius: 16px;\r\n  border: 1px solid var(--border-mid);\r\n  background: #ffffff;\r\n  color: #4a3c78;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: 0.2s ease;\r\n  white-space: nowrap;\r\n  font-family: inherit;\r\n  font-size: 14px;\r\n}\r\n\r\n.zf-btn:hover {\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.zf-btn--gradient {\r\n  border: none;\r\n  color: #ffffff;\r\n  background: linear-gradient(90deg, #8b1eff 0%, #3c68ff 100%);\r\n  box-shadow: 0 10px 24px rgba(88, 62, 255, 0.28);\r\n}\r\n\r\n.zf-btn--ghost {\r\n  background: #ffffff;\r\n  color: #4f4672;\r\n}\r\n\r\n.zf-btn--outline {\r\n  background: #ffffff;\r\n  color: #6b57a8;\r\n  border: 1px solid #ddd1fa;\r\n}\r\n\r\n/* ===================================\r\n   BADGES\r\n   =================================== */\r\n\r\n.zf-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-height: 28px;\r\n  padding: 0 14px;\r\n  border-radius: 999px;\r\n  background: #efe9ff;\r\n  color: #6c3bff;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n}\r\n\r\n.zf-badge--soft {\r\n  background: #f3efff;\r\n  color: #7a58e6;\r\n}\r\n\r\n.zf-chip {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  min-height: 30px;\r\n  padding: 0 12px;\r\n  border-radius: 999px;\r\n  background: #f1ecff;\r\n  color: #7d23ff;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n}\r\n\r\n/* ===================================\r\n   INFO TILE GRID\r\n   (ficha de datos personales - \"Ver Paciente\",\r\n   mismo lenguaje visual que el panel de\r\n   paciente de la barra lateral)\r\n   =================================== */\r\n\r\n.zf-info-tile-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, 1fr);\r\n  gap: 10px;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n@media (min-width: 700px) {\r\n  .zf-info-tile-grid {\r\n    grid-template-columns: repeat(4, 1fr);\r\n  }\r\n}\r\n\r\n.zf-info-tile {\r\n  border: 1px solid var(--border-soft);\r\n  border-radius: 12px;\r\n  padding: 10px 12px;\r\n  background: var(--bg-card);\r\n}\r\n\r\n.zf-info-tile__label {\r\n  font-size: 11px;\r\n  color: var(--text-soft);\r\n  margin-bottom: 3px;\r\n}\r\n\r\n.zf-info-tile__value {\r\n  font-size: 13px;\r\n  color: var(--text-main);\r\n  font-weight: 500;\r\n  word-break: break-word;\r\n}\r\n\r\n.zf-info-tile.empty .zf-info-tile__value {\r\n  color: var(--text-soft);\r\n  font-weight: 400;\r\n}\r\n\r\n/* ===================================\r\n   DOCUMENT BROWSER (Documentos clinicos)\r\n   =================================== */\r\n\r\n.zf-dropzone {\r\n  border: 2px dashed var(--border-mid);\r\n  border-radius: 16px;\r\n  padding: 24px 20px;\r\n  text-align: center;\r\n  background: var(--bg-card);\r\n  cursor: pointer;\r\n  transition: border-color 0.15s ease, background 0.15s ease;\r\n}\r\n\r\n.zf-dropzone.dragover {\r\n  border-color: var(--primary);\r\n  background: #f1ecff;\r\n}\r\n\r\n.zf-dropzone__icon {\r\n  font-size: 24px;\r\n  color: var(--text-soft);\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.zf-dropzone__main {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: var(--text-main);\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.zf-dropzone__sub {\r\n  font-size: 12px;\r\n  color: var(--text-soft);\r\n}\r\n\r\n.zf-selected-file {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  margin-top: 12px;\r\n  padding: 9px 12px;\r\n  border: 1px solid var(--border-soft);\r\n  border-radius: 12px;\r\n  background: var(--bg-card);\r\n  font-size: 13px;\r\n}\r\n\r\n.zf-selected-file__name {\r\n  font-weight: 600;\r\n  flex: 1;\r\n}\r\n\r\n.zf-selected-file__remove {\r\n  cursor: pointer;\r\n  color: var(--text-soft);\r\n  font-size: 15px;\r\n}\r\n\r\n.zf-field-row {\r\n  margin-top: 12px;\r\n}\r\n\r\n.zf-field-row label {\r\n  display: block;\r\n  font-size: 12px;\r\n  color: var(--text-soft);\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.zf-field-row input[type=\"text\"] {\r\n  width: 100%;\r\n  padding: 9px 12px;\r\n  border: 1px solid var(--border-mid);\r\n  border-radius: 10px;\r\n  font-size: 14px;\r\n  font-family: inherit;\r\n}\r\n\r\n.zf-btn-gradient {\r\n  padding: 9px 18px;\r\n  border-radius: 10px;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  border: none;\r\n  cursor: pointer;\r\n  color: #fff;\r\n  background: linear-gradient(90deg, #8b1eff 0%, #3c68ff 100%);\r\n  font-family: inherit;\r\n}\r\n\r\n.zf-btn-gradient:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.zf-search-box {\r\n  flex: 1;\r\n  min-width: 180px;\r\n  max-width: 260px;\r\n  padding: 7px 12px;\r\n  border: 1px solid var(--border-mid);\r\n  border-radius: 10px;\r\n  font-size: 13px;\r\n  font-family: inherit;\r\n}\r\n\r\n.zf-doc-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  max-height: 320px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.zf-doc-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 9px 12px;\r\n  border: 1px solid var(--border-soft);\r\n  border-radius: 12px;\r\n  background: var(--bg-surface);\r\n}\r\n\r\n.zf-doc-row__icon {\r\n  font-size: 18px;\r\n  color: var(--text-soft);\r\n  flex-shrink: 0;\r\n  display: flex;\r\n}\r\n\r\n.zf-doc-row__icon .material-icons {\r\n  font-size: 20px;\r\n}\r\n\r\n.zf-doc-row__info {\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.zf-doc-row__name {\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  color: var(--text-main);\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.zf-doc-row__meta {\r\n  font-size: 11px;\r\n  color: var(--text-soft);\r\n  margin-top: 2px;\r\n}\r\n\r\n.zf-doc-row__tag {\r\n  font-size: 10px;\r\n  padding: 2px 8px;\r\n  border-radius: 999px;\r\n  background: #f1ecff;\r\n  color: var(--primary);\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n}\r\n\r\n.zf-doc-row__tag--empty {\r\n  opacity: 0.5;\r\n}\r\n\r\n.zf-doc-row__actions {\r\n  display: flex;\r\n  gap: 6px;\r\n}\r\n\r\n.zf-doc-row__actions button {\r\n  width: 28px;\r\n  height: 28px;\r\n  border-radius: 8px;\r\n  border: 1px solid var(--border-mid);\r\n  background: #fff;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: var(--text-soft);\r\n}\r\n\r\n.zf-doc-row__actions .material-icons {\r\n  font-size: 16px;\r\n}\r\n\r\n.zf-doc-row--eliminado {\r\n  background: #f7f5fc;\r\n  opacity: 0.85;\r\n}\r\n\r\n.zf-doc-row--eliminado .zf-doc-row__name {\r\n  text-decoration: line-through;\r\n  color: var(--text-soft);\r\n  font-weight: 500;\r\n}\r\n\r\n.zf-doc-row__motivo {\r\n  font-size: 11px;\r\n  color: var(--text-soft);\r\n  font-style: italic;\r\n  margin-top: 2px;\r\n  white-space: normal;\r\n}\r\n\r\n/* ===================================\r\n   INPUTS\r\n   =================================== */\r\n\r\n.zf-input,\r\n.zf-select,\r\n.zf-textarea {\r\n  width: 100%;\r\n  min-height: 44px;\r\n  border-radius: 14px;\r\n  border: 1px solid #dcd6e8;\r\n  background: #ffffff;\r\n  padding: 12px 14px;\r\n  outline: none;\r\n  font-size: 14px;\r\n  color: var(--text-main);\r\n  font-family: inherit;\r\n}\r\n\r\n.zf-textarea {\r\n  min-height: 110px;\r\n  resize: vertical;\r\n}\r\n\r\n.zf-input:focus,\r\n.zf-select:focus,\r\n.zf-textarea:focus {\r\n  border-color: #bbaaf6;\r\n  box-shadow: 0 0 0 4px rgba(130, 90, 255, 0.08);\r\n}\r\n\r\n/* ===================================\r\n   SEARCH\r\n   =================================== */\r\n\r\n.zf-search {\r\n  flex: 1;\r\n  max-width: 460px;\r\n  position: relative;\r\n}\r\n\r\n.zf-search__icon {\r\n  position: absolute;\r\n  left: 16px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  font-size: 14px;\r\n  opacity: 0.75;\r\n}\r\n\r\n.zf-search input {\r\n  width: 100%;\r\n  height: 46px;\r\n  border-radius: 16px;\r\n  border: 1px solid var(--border-mid);\r\n  background: #ffffff;\r\n  padding: 0 16px 0 44px;\r\n  outline: none;\r\n  font-size: 14px;\r\n  color: var(--text-main);\r\n  box-shadow: 0 2px 8px rgba(34, 24, 68, 0.04);\r\n}\r\n\r\n.zf-search input:focus {\r\n  border-color: #bbaaf6;\r\n  box-shadow: 0 0 0 4px rgba(130, 90, 255, 0.08);\r\n}\r\n\r\n/* ===================================\r\n   TOPBAR\r\n   =================================== */\r\n\r\n.zf-topbar {\r\n  flex: 0 0 auto;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 18px;\r\n  padding: 22px 28px 18px;\r\n}\r\n\r\n.zf-topbar__actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 14px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n/* ===================================\r\n   PATIENT PANEL (SIDEBAR)\r\n   =================================== */\r\n\r\n.zf-patient-panel {\r\n  margin-top: 18px;\r\n  padding: 16px;\r\n  background: rgba(255, 255, 255, 0.06);\r\n  border: 1px solid rgba(255, 255, 255, 0.1);\r\n  border-radius: 18px;\r\n}\r\n\r\n.zf-patient-panel__label {\r\n  display: block;\r\n  font-size: 11px;\r\n  letter-spacing: 0.18em;\r\n  color: rgba(255, 255, 255, 0.56);\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.zf-patient-panel h3 {\r\n  margin: 0 0 8px;\r\n  font-size: 16px;\r\n  line-height: 1.35;\r\n  color: #ffffff;\r\n}\r\n\r\n.zf-patient-panel__sub {\r\n  font-size: 13px;\r\n  color: rgba(255, 255, 255, 0.82);\r\n  margin-bottom: 14px;\r\n}\r\n\r\n.zf-patient-panel__data {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n  padding-top: 12px;\r\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\r\n}\r\n\r\n.zf-patient-panel__data p {\r\n  margin: 0;\r\n  font-size: 12px;\r\n  color: rgba(255, 255, 255, 0.72);\r\n}\r\n\r\n.zf-patient-panel__data strong {\r\n  color: rgba(255, 255, 255, 0.92);\r\n  font-weight: 600;\r\n}\r\n\r\n.zf-patient-panel__chip-row {\r\n  display: flex;\r\n  gap: 6px;\r\n  margin-bottom: 12px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.zf-patient-panel__chip {\r\n  font-size: 11px;\r\n  padding: 3px 9px;\r\n  border-radius: 999px;\r\n  background: rgba(141, 29, 255, 0.35);\r\n  color: #e6d6ff;\r\n  font-weight: 600;\r\n}\r\n\r\n.zf-patient-panel__vermas {\r\n  margin-top: 10px;\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  color: rgba(255, 255, 255, 0.6);\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  padding: 0;\r\n  font-family: inherit;\r\n}\r\n\r\n.zf-patient-panel__vermas-arrow {\r\n  transition: transform 0.15s ease;\r\n  display: inline-block;\r\n}\r\n\r\n.zf-patient-panel__vermas.open .zf-patient-panel__vermas-arrow {\r\n  transform: rotate(180deg);\r\n}\r\n\r\n.zf-patient-panel__extra {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n  margin-top: 10px;\r\n  padding-top: 10px;\r\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\r\n}\r\n\r\n.zf-patient-panel__extra p {\r\n  margin: 0;\r\n  font-size: 12px;\r\n  color: rgba(255, 255, 255, 0.72);\r\n}\r\n\r\n.zf-patient-panel__extra strong {\r\n  color: rgba(255, 255, 255, 0.92);\r\n  font-weight: 600;\r\n}\r\n\r\n/* ===================================\r\n   COLLAPSIBLE SECTIONS\r\n   =================================== */\r\n\r\n.zf-section-box {\r\n  background: var(--bg-surface);\r\n  border: 1px solid var(--border-soft);\r\n  border-radius: 18px;\r\n  margin-bottom: 16px;\r\n  overflow: hidden;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.zf-section-box__header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 18px 22px;\r\n  cursor: pointer;\r\n  user-select: none;\r\n}\r\n\r\n.zf-section-box__title-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n.zf-section-box__header h3 {\r\n  margin: 0;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  color: var(--text-main);\r\n}\r\n\r\n.zf-section-box__toggle {\r\n  width: 32px;\r\n  height: 32px;\r\n  border-radius: 10px;\r\n  border: 1px solid var(--border-mid);\r\n  background: white;\r\n  color: var(--primary);\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  line-height: 1;\r\n}\r\n\r\n.zf-section-box__toggle:hover {\r\n  background: var(--bg-card);\r\n  border-color: var(--primary);\r\n}\r\n\r\n.zf-section-box__body {\r\n  padding: 0 22px 22px;\r\n  display: none;\r\n}\r\n\r\n.zf-section-box.is-open .zf-section-box__body {\r\n  display: block;\r\n}\r\n\r\n.zf-section-box.is-collapsed .zf-section-box__body {\r\n  display: none;\r\n}\r\n\r\n/* ===================================\r\n   MINI BADGE (OBLIGATORIO)\r\n   =================================== */\r\n\r\n.zf-mini-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  height: 22px;\r\n  padding: 0 12px;\r\n  border-radius: 999px;\r\n  background: #fff3e6;\r\n  color: #e67700;\r\n  font-family: 'Rubik', sans-serif;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  letter-spacing: 0.03em;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.zf-mini-badge--required {\r\n  background: #ffe6e6;\r\n  color: #cc0000;\r\n}\r\n\r\n.zf-mini-badge--info {\r\n  background: #e6f3ff;\r\n  color: #0066cc;\r\n}\r\n\r\n.zf-mini-badge--brand {\r\n  background: #f1ecff;\r\n  color: #7d23ff;\r\n}\r\n\r\n.zf-mini-badge--action {\r\n  border: none;\r\n  appearance: none;\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n  margin: 1px 0 0;\r\n  vertical-align: top;\r\n  cursor: pointer;\r\n  transition: filter 0.15s ease;\r\n}\r\n\r\n.zf-mini-badge--action:hover {\r\n  filter: brightness(0.95);\r\n}\r\n\r\n.zf-mini-badge--action:disabled {\r\n  cursor: default;\r\n  opacity: 0.5;\r\n}\r\n\r\n/* ===================================\r\n   CONSULT LAYOUT\r\n   =================================== */\r\n\r\n.zf-consult-wrapper {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 24px 28px;\r\n}\r\n\r\n.zf-consult-card {\r\n  background: var(--bg-surface);\r\n  border: 1px solid var(--border-soft);\r\n  border-radius: 24px;\r\n  overflow: hidden;\r\n  box-shadow: 0 4px 20px rgba(44, 33, 80, 0.06);\r\n}\r\n\r\n.zf-consult-card__header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  flex-wrap: wrap;\r\n  gap: 24px;\r\n  padding: 24px 28px;\r\n  border-bottom: 1px solid var(--border-soft);\r\n}\r\n\r\n/* Los distintivos no se encogen (flex-shrink: 0 mas abajo), asi que todo el\r\n   apretujon caia sobre el nombre del paciente: con edad, tipo de cita y\r\n   modalidad en la misma fila, quedaba en \"Ju...\". Ahora la fila envuelve y el\r\n   nombre tiene un piso: si falta espacio bajan los distintivos, no el nombre. */\r\n.zf-consult-card__title-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  row-gap: 8px;\r\n  flex-wrap: wrap;\r\n  flex: 1 1 260px;\r\n  min-width: 0;\r\n}\r\n\r\n.zf-consult-card__title-row h2 {\r\n  margin: 0;\r\n  font-size: 22px;\r\n  color: var(--text-main);\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  /* Piso legible: sigue recortando con puntos suspensivos si el nombre es muy\r\n     largo, pero nunca se reduce a dos letras. */\r\n  min-width: 180px;\r\n}\r\n\r\n.zf-consult-card__title-row .zf-chip {\r\n  flex-shrink: 0;\r\n}\r\n\r\n.zf-consult-card__header-actions {\r\n  display: flex;\r\n  gap: 12px;\r\n  flex-wrap: wrap;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.zf-consult-layout {\r\n  display: grid;\r\n  grid-template-columns: 1fr 320px;\r\n  gap: 24px;\r\n  padding: 24px 28px;\r\n}\r\n\r\n.zf-consult-maincol {\r\n  min-width: 0;\r\n}\r\n\r\n.zf-consult-sidebar {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n}\r\n\r\n/* ===================================\r\n   CONSULT TOPBAR\r\n   =================================== */\r\n\r\n.zf-consult-topbar {\r\n  flex: 0 0 auto;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 18px;\r\n  padding: 22px 28px 18px;\r\n  border-bottom: 1px solid var(--border-soft);\r\n}\r\n\r\n.zf-consult-topbar__eyebrow {\r\n  display: block;\r\n  font-size: 11px;\r\n  letter-spacing: 0.14em;\r\n  color: var(--text-soft);\r\n  margin-bottom: 6px;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.zf-consult-topbar__title {\r\n  margin: 0;\r\n  font-size: 26px;\r\n  color: var(--text-main);\r\n}\r\n\r\n/* ===================================\r\n   RESPONSIVE\r\n   =================================== */\r\n\r\n@media (max-width: 1180px) {\r\n  .zf-topbar {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n  }\r\n\r\n  .zf-search {\r\n    max-width: none;\r\n  }\r\n\r\n  .zf-consult-layout {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n@media (max-width: 980px) {\r\n  .zf-sidebar {\r\n    display: none;\r\n  }\r\n\r\n  .zf-sidebar.zf-sidebar--mobile-open {\r\n    display: flex;\r\n    position: fixed;\r\n    inset: 0 auto 0 0;\r\n    width: 84%;\r\n    max-width: 300px;\r\n    min-width: 0;\r\n    z-index: 31;\r\n    box-shadow: 0 0 40px rgba(0, 0, 0, 0.35);\r\n  }\r\n\r\n  .zf-sidebar__mobile-close {\r\n    display: flex;\r\n    align-self: flex-end;\r\n    width: 32px;\r\n    height: 32px;\r\n    border: none;\r\n    border-radius: 8px;\r\n    background: rgba(255, 255, 255, 0.1);\r\n    color: var(--white);\r\n    font-size: 16px;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    margin-bottom: 8px;\r\n  }\r\n\r\n  .zf-mobile-topbar {\r\n    display: flex;\r\n  }\r\n\r\n  .zf-sidebar-overlay {\r\n    display: block;\r\n    position: fixed;\r\n    inset: 0;\r\n    background: rgba(10, 5, 30, 0.5);\r\n    z-index: 30;\r\n  }\r\n\r\n  .zf-app-shell {\r\n    flex-direction: column;\r\n    height: auto;\r\n    min-height: 100vh;\r\n    overflow: visible;\r\n  }\r\n\r\n  .zf-main {\r\n    height: auto;\r\n    overflow: visible;\r\n  }\r\n\r\n  .zf-topbar {\r\n    padding: 16px;\r\n  }\r\n\r\n  .zf-consult-wrapper {\r\n    padding: 16px;\r\n  }\r\n\r\n  .zf-consult-card__header {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n  }\r\n}\r\n\r\n/* Reduccion de padding especifica para telefonos - el breakpoint de arriba\r\n   (980px) sigue cubriendo tablets, que tienen espacio de sobra y no lo\r\n   necesitan; este es mas angosto a proposito. */\r\n@media (max-width: 600px) {\r\n  .zf-main {\r\n    padding: 12px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
